define.alias("shared/components/shared/post/secondary/caption-writer/body", "media/components/shared/post/secondary/caption-writer/body");